// extracted by mini-css-extract-plugin
export default {"container":"mobile-header_container__sBM-V","content":"mobile-header_content__JJyzr","logo":"mobile-header_logo__qPlh6"};